import { put, takeLatest, call } from "redux-saga/effects";
import MedicamentoActions, {
  Types as MedicamentoTypes,
} from "../../stores/medicamento/Actions";
import MedicamentoService from "../../services/medicamento/MedicamentoService";
import AutorizacionService from "../../services/autorizacion/AutorizacionService";
import ProcedimientoService from "../../services/procedimiento/ProcedimientoService";
import AuthService from "../../services/auth/AuthService";
import OrdsInfoplanService from "../../services/ordsInfoplan/OrdsInfoplanService";
import ResponseCode from "../../services/ResponseCode";
import { getActualYear, getActualDate } from "../../utils/DateUtils";
import {
  DEFAULT_MOTIVO_CANCELACION,
  COBERTURAS_MONTOS_MODIFICABLES,
  CODIGO_TIPO_SERVICIO_MEDICAMENTO,
  ESTADO_DIAGNOSTICO_DEFINITIVO,
  CHECK_DIAGNOSTICO_DEFINITIVO,
} from "../../containers/medicamento/utils/MedicamentoConstant";
import {
  getObjetoMedicamento,
  desfragmentarCodigoMedicamento,
  fragmentarCodigoMedicamento,
  agruparObjetoMedicamento,
} from "../../containers/medicamento/utils/MedicamentoUtils";
import { groupBy } from "../../utils/ArrayUtil";
import { isEmptyValue, cleanString } from "../../utils/StringUtil";
import {
  isValidNumber,
  isServerErrorResponseCode,
  isServerErrorResponseMessage,
  isServerErrorResponse,
} from "../../utils/ValidationUtil";
import { DATE_FORMATS } from "../../utils/Constant";
import moment from "moment";

function* crearMedicamento(request) {
  yield put(MedicamentoActions.crearMedicamentoLoading());

  const { numeroSesion, procedimientos, tipoServicio, servicio } =
    request.payload;

  let procedimientosNoInsertados = [];

  for (let procedimiento of procedimientos) {
    let requestValidar = {
      codigoProcedimiento: procedimiento?.cobertura,
      tipoServicio,
      frecuencia: procedimiento?.cantidad,
    };

    if (
      (COBERTURAS_MONTOS_MODIFICABLES.includes(procedimiento?.cobertura) ||
        Number(servicio) ===
          Number(CODIGO_TIPO_SERVICIO_MEDICAMENTO.ALTO_COSTO)) &&
      !isEmptyValue(procedimiento?.montoReclamado) &&
      Number(procedimiento?.montoReclamado) > 0
    ) {
      requestValidar.monto = Number(procedimiento?.montoReclamado);
    }

    const validarProcedimientoResponse = yield call(
      ProcedimientoService.validarProcedimiento,
      AuthService.handleRequestSession(requestValidar, numeroSesion)
    );

    if (isServerErrorResponseMessage(validarProcedimientoResponse)) {
      procedimientosNoInsertados.push(procedimiento?.cobertura);
    }

    const requestInsertar = {
      frecuencia: procedimiento?.cantidad,
    };

    const insertarProcedimientoResponse = yield call(
      ProcedimientoService.insertarProcedimiento,
      AuthService.handleRequestSession(requestInsertar, numeroSesion)
    );

    if (isServerErrorResponseCode(insertarProcedimientoResponse)) {
      procedimientosNoInsertados.push(procedimiento?.cobertura);
    }
  }

  const crearMedicamentoResponse = yield call(
    MedicamentoService.crearMedicamento,
    AuthService.handleRequestSession(
      request.payload?.requestAutorizar,
      numeroSesion
    )
  );

  if (isServerErrorResponse(crearMedicamentoResponse)) {
    yield put(
      MedicamentoActions.crearMedicamentoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (crearMedicamentoResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      MedicamentoActions.crearMedicamentoFailure(
        crearMedicamentoResponse?.respuesta
      )
    );
    return;
  }

  const { compania, medicamento } = crearMedicamentoResponse?.data;

  const esMedicamentoMadre =
    crearMedicamentoResponse?.data?.esMedicamentoMadre;

  let errorRegistrarInfo = null;

  if (request.payload.insertarMetadata) {
    const {
      contacto,
      diagnosticos,
      medicoTratante,
      comentarios,
      exentoDeFisico,
    } = request.payload?.requestRegistrarInfo;

    if (esMedicamentoMadre) {
      const medicamentoHumano = desfragmentarCodigoMedicamento(
        crearMedicamentoResponse?.data?.medicamentosRelacionados?.medicamentoHumano?.toUpperCase()
      );

      const medicamentoPrimera = desfragmentarCodigoMedicamento(
        crearMedicamentoResponse?.data?.medicamentosRelacionados?.medicamentoPrimera?.toUpperCase()
      );

      if (medicamentoHumano) {
        const requestRegistrarInfoMedicamentoHumano = {
          anio: getActualYear(),
          compania: medicamentoHumano?.compania,
          ramo: medicamentoHumano?.ramo,
          secuencial: medicamentoHumano?.secuencial,
          contacto: contacto,
          diagnosticos: diagnosticos,
          medicoTratante: medicoTratante,
          comentarios: comentarios,
          exentoDeFisico: exentoDeFisico,
        };

        const responseRegistrarInfoHumano = yield call(
          MedicamentoService.registrarInfoMedicamento,
          requestRegistrarInfoMedicamentoHumano
        );

        errorRegistrarInfo = responseRegistrarInfoHumano?.error;

        if (exentoDeFisico) {
          const { documents } = request.payload;
          for (const documento of documents) {
            let formData = new FormData();
            formData.append("anio", getActualYear());
            formData.append("compania", medicamentoHumano?.compania);
            formData.append("ramo", medicamentoHumano?.ramo);
            formData.append("secuencial", medicamentoHumano?.secuencial);
            formData.append("descripcion", "Papper Free");
            formData.append("file", documento);
            yield call(MedicamentoService.subirArchivoMedicamento, formData);
          }
        }
      }

      if (medicamentoPrimera) {
        const requestRegistrarInfoMedicamentoPrimera = {
          anio: getActualYear(),
          compania: medicamentoPrimera?.compania,
          ramo: medicamentoPrimera?.ramo,
          secuencial: medicamentoPrimera?.secuencial,
          contacto: contacto,
          diagnosticos: diagnosticos,
          medicoTratante: medicoTratante,
          comentarios: comentarios,
          exentoDeFisico: exentoDeFisico,
        };

        const responseRegistrarInfoPrimera = yield call(
          MedicamentoService.registrarInfoMedicamentoPrimera,
          requestRegistrarInfoMedicamentoPrimera
        );

        errorRegistrarInfo =
          errorRegistrarInfo === null
            ? responseRegistrarInfoPrimera?.data?.error
            : responseRegistrarInfoPrimera?.data?.error !== null
            ? `${errorRegistrarInfo} , ${responseRegistrarInfoPrimera?.data?.error}`
            : null;

        if (exentoDeFisico) {
          const { documents } = request.payload;
          for (const documento of documents) {
            let formData = new FormData();
            formData.append("anio", getActualYear());
            formData.append("compania", medicamentoPrimera?.compania);
            formData.append("ramo", medicamentoPrimera?.ramo);
            formData.append("secuencial", medicamentoPrimera?.secuencial);
            formData.append("descripcion", "Papper Free");
            formData.append("file", documento);
            yield call(MedicamentoService.subirArchivoMedicamento, formData);
          }
        }
      }
    } else {
      const requestRegistrarInfoMedicamento = {
        anio: getActualYear(),
        compania: compania?.codigo,
        ramo: medicamento?.ramo,
        secuencial: medicamento?.secuencial,
        contacto: contacto,
        diagnosticos: diagnosticos,
        medicoTratante: medicoTratante,
        comentarios: comentarios,
        exentoDeFisico: exentoDeFisico,
      };

      const responseRegistrarInfo = yield call(
        MedicamentoService.registrarInfoMedicamento,
        requestRegistrarInfoMedicamento
      );

      errorRegistrarInfo = responseRegistrarInfo?.error;

      if (exentoDeFisico) {
        const { documents } = request.payload;
        for (const documento of documents) {
          let formData = new FormData();
          formData.append("anio", getActualYear());
          formData.append("compania", compania?.codigo);
          formData.append("ramo", medicamento?.ramo);
          formData.append("secuencial", medicamento?.secuencial);
          formData.append("descripcion", "Papper Free");
          formData.append("file", documento);
          yield call(MedicamentoService.subirArchivoMedicamento, formData);
        }
      }
    }
  }

  let infoMedicamentoMadre = null;

  if (esMedicamentoMadre) {
    const medicamentoMadre = desfragmentarCodigoMedicamento(
      crearMedicamentoResponse?.data?.medicamento?.numeroMedicamento?.toUpperCase()
    );

    const requestDetalleMadre = {
      numeroMedicamentoMadre: `${getActualYear()}${
        medicamentoMadre?.compania
      }${medicamentoMadre?.ramo}${medicamentoMadre?.secuencial}`,
    };

    const getMedicamentoMadreResponse = yield call(
      MedicamentoService.getDetalleMedicamentoMadre,
      requestDetalleMadre
    );

    infoMedicamentoMadre = getMedicamentoMadreResponse?.data;
  }

  let mensajeProcedimientosNoInsertados = null;

  if (procedimientosNoInsertados?.length > 0) {
    let procedimientosFiltrados = [...new Set(procedimientosNoInsertados)];

    mensajeProcedimientosNoInsertados =
      "No se insertaron los siguientes procedimientos: " +
      procedimientosFiltrados?.join(", ");
  }

  yield put(
    MedicamentoActions.crearMedicamentoSuccess({
      compania,
      medicamento,
      errorRegistrarInfo,
      esMedicamentoMadre,
      medicamentosRelacionados:
        crearMedicamentoResponse?.data?.medicamentosRelacionados,
      infoMedicamentoMadre,
      mensajeProcedimientosNoInsertados,
    })
  );
}

function* cancelarMedicamento(request) {
  yield put(MedicamentoActions.cancelarMedicamentoLoading());

  const { numeroSesion, medicamento } = request.payload;

  const requestCancelar = {
    numeroMedicamento: medicamento?.numeroMedicamento,
    numeroPlastico: medicamento?.numeroAsegurado,
    codigoMotivo: DEFAULT_MOTIVO_CANCELACION,
  };

  const cancelarMedicamentoResponse = yield call(
    MedicamentoService.cancelarMedicamento,
    AuthService.handleRequestSession(requestCancelar, numeroSesion)
  );

  if (!cancelarMedicamentoResponse?.respuesta) {
    yield put(
      MedicamentoActions.cancelarMedicamentoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    cancelarMedicamentoResponse?.respuesta?.codigo ===
    ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      MedicamentoActions.cancelarMedicamentoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    cancelarMedicamentoResponse?.respuesta?.codigo !== ResponseCode.OK.code
  ) {
    yield put(
      MedicamentoActions.cancelarMedicamentoFailure(
        cancelarMedicamentoResponse?.respuesta
      )
    );
    return;
  }

  yield put(MedicamentoActions.cancelarMedicamentoSuccess({ medicamento }));
}

function* getMedicamento(request) {
  yield put(MedicamentoActions.getMedicamentoLoading());

  const { numeroMedicamento, ano, tipoPss, codigoPss, desdePantallaConsulta } =
    request.payload;

  const getMedicamentoResponse = yield call(
    MedicamentoService.getDetalleMedicamento,
    { numeroMedicamento, ano }
  );

  if (!getMedicamentoResponse?.respuesta) {
    yield put(
      MedicamentoActions.getMedicamentoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    getMedicamentoResponse?.respuesta?.codigo ===
    ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      MedicamentoActions.getMedicamentoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (getMedicamentoResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      MedicamentoActions.getMedicamentoFailure(
        getMedicamentoResponse?.respuesta
      )
    );
    return;
  }

  const { data } = getMedicamentoResponse;

  let dataGmm = null;

  if (data?.reclamacionGmm) {
    const numeroMedicamentoGmm = fragmentarCodigoMedicamento(
      data?.reclamacionGmm?.compania,
      data?.reclamacionGmm?.ramo,
      data?.reclamacionGmm?.secuencial
    );

    const medicamentoGmmResponse = yield call(
      MedicamentoService.getDetalleMedicamento,
      { numeroMedicamento: numeroMedicamentoGmm, ano }
    );

    if (medicamentoGmmResponse?.data?.procedimientos?.length > 0) {
      dataGmm = {
        ...medicamentoGmmResponse?.data,
        numeroMedicamento: numeroMedicamentoGmm,
      };
    }
  }

  const objetoMedicamento = getObjetoMedicamento(
    data?.reclamacion?.numeroMedicamento
  );

  const getInfoRequest = {
    Anio: objetoMedicamento?.anio,
    Compania: objetoMedicamento?.compania,
    Ramo: objetoMedicamento?.ramo,
    Secuencial: objetoMedicamento?.secuencial,
    FechaServicioDesde: moment(objetoMedicamento?.fecha).format(
      DATE_FORMATS.middledash_ymd
    ),
    FechaServicioHasta: getActualDate(),
    TipoReclamante: tipoPss,
    Reclamante: codigoPss,
  };

  const infoResponse = yield call(
    MedicamentoService.getInfoMedicamento,
    getInfoRequest
  );

  const info = infoResponse?.length > 0 ? infoResponse[0] : null;

  let infoMedicamentoMadre = null;

  if (desdePantallaConsulta && data?.reclamacion?.numeroMedicamentoMadre) {
    const requestDetalleMadre = {
      numeroMedicamentoMadre: data?.reclamacion?.numeroMedicamentoMadre,
    };

    const getMedicamentoMadreResponse = yield call(
      MedicamentoService.getDetalleMedicamentoMadre,
      requestDetalleMadre
    );

    infoMedicamentoMadre = getMedicamentoMadreResponse?.data;
  }

  yield put(
    MedicamentoActions.getMedicamentoSuccess({
      data,
      dataGmm,
      info,
      medicamentoLegacy: objetoMedicamento,
      infoMedicamentoMadre,
      mostrarMontosMadre: infoMedicamentoMadre !== null,
    })
  );
}

function* reactivarMedicamento(request) {
  yield put(MedicamentoActions.reactivarMedicamentoLoading());

  const response = yield call(
    MedicamentoService.reactivarMedicamento,
    request.payload
  );

  if (!response?.respuesta) {
    yield put(
      MedicamentoActions.reactivarMedicamentoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code) {
    yield put(
      MedicamentoActions.reactivarMedicamentoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (response?.respuesta?.mensaje !== ResponseCode.OK.message) {
    yield put(
      MedicamentoActions.reactivarMedicamentoFailure(response?.respuesta)
    );
    return;
  }

  const { data } = response;

  yield put(MedicamentoActions.reactivarMedicamentoSuccess(data));
}

function* consultarMedicamentos(request) {
  const {
    numeroBusqueda,
    fechaInicio,
    fechaFin,
    compania,
    prefijo,
    pagina,
    tamanoPagina,
  } = request.payload;

  yield put(MedicamentoActions.consultarMedicamentosLoading());

  let requestMedicamentos = {
    FechaInicio: fechaInicio,
    FechaFin: fechaFin,
    Compania: compania,
    Pagina: pagina,
    TamanoPagina: tamanoPagina,
  };

  if (!isEmptyValue(numeroBusqueda)) {
    if (isValidNumber(numeroBusqueda)) {
      requestMedicamentos.NumeroPlastico = numeroBusqueda;
    } else {
      try {
        const medicamento = desfragmentarCodigoMedicamento(
          numeroBusqueda?.toUpperCase()
        );
        requestMedicamentos.Ramo = medicamento?.ramo || 0;
        requestMedicamentos.Secuencial = medicamento?.secuencial || 0;
      } catch (error) {}
    }
  }

  const response = yield call(
    MedicamentoService.getMedicamentos,
    requestMedicamentos
  );

  if (
    !response?.respuesta ||
    response?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code
  ) {
    yield put(
      MedicamentoActions.consultarMedicamentosFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (
    response?.respuesta?.mensaje?.toLowerCase() !==
    ResponseCode.OK.message.toLowerCase()
  ) {
    yield put(
      MedicamentoActions.consultarMedicamentosFailure(response?.respuesta)
    );
    return;
  }

  const result = {
    paginacion: response?.paginacion,
    medicamentos: response?.data?.medicamentos
      ?.map((medicamento) => {
        return {
          key: medicamento?.secuencial,
          numeroMedicamento: `${prefijo}${+medicamento?.ramo}-${
            medicamento?.secuencial
          }`,
          fechaServicio: medicamento?.fechaApertura,
          numeroAsegurado: medicamento?.numeroPlastico,
          estado: medicamento?.estatus,
          descripcionEstatus: medicamento?.descripcionEstatus,
          numeroMedicamentoMadre: medicamento?.numeroMedicamentoMadre,
        };
      })
      ?.sort((a, b) => {
        const fechaA = new Date(a.fechaServicio);
        const fechaB = new Date(b.fechaServicio);
        return fechaB - fechaA;
      }),
  };

  yield put(MedicamentoActions.consultarMedicamentosSuccess(result));
}

function* limpiarDatosMedicamento() {
  yield put(MedicamentoActions.limpiarDatosMedicamentoLoading());

  yield put(MedicamentoActions.crearMedicamentoSuccess({}));
}

export function* formMedicamentoDiagnostico(request) {
  yield put(MedicamentoActions.formMedicamentoDiagnosticoLoading());

  yield put(
    MedicamentoActions.formMedicamentoDiagnosticoSuccess(request?.payload)
  );
}

function* getMedicamentosDiagnostico(request) {
  yield put(MedicamentoActions.getMedicamentosDiagnosticoLoading());

  const {
    fechaInicio,
    fechaFin,
    tipoReclamante,
    reclamante,
    compania,
    formMedicamentoDiagnosticoData,
  } = request.payload;

  const getMedicamentosRequest = {
    Compania: compania,
    FechaServicioDesde: moment(fechaInicio).format(DATE_FORMATS.middledash_ymd),
    FechaServicioHasta: moment(fechaFin).format(DATE_FORMATS.middledash_ymd),
    TipoReclamante: tipoReclamante,
    Reclamante: reclamante,
  };

  const getMedicamentosResponse = yield call(
    MedicamentoService.getInfoMedicamento,
    getMedicamentosRequest
  );

  let result = [];

  if (getMedicamentosResponse?.length > 0) {
    let agrupadasPorMedicamento = groupBy(
      getMedicamentosResponse,
      "numeroMedicamento"
    );

    agrupadasPorMedicamento.forEach((medicamentoAagrupado) => {
      result.push(agruparObjetoMedicamento(medicamentoAagrupado));
    });

    result = result.map((medicamento) => {
      return {
        ...medicamento,
        key: medicamento.numeroMedicamento,
        esDiagnosticoDefinitivo:
          medicamento?.diagnosticoMetaData?.esDiagnosticoDefinitivo,
        estado: medicamento?.diagnosticoMetaData?.esDiagnosticoDefinitivo
          ? ESTADO_DIAGNOSTICO_DEFINITIVO.CONFIRMADO
          : ESTADO_DIAGNOSTICO_DEFINITIVO.PENDIENTE_CONFIRMAR,
      };
    });

    const sortDates = (a, b) =>
      moment(a.fechaServicio) - moment(b.fechaServicio);

    result = result.sort(sortDates);

    result = result?.filter((item) => item.esDiagnosticoDefinitivo === false);

    yield put(
      MedicamentoActions.formMedicamentoDiagnosticoSuccess({
        ...formMedicamentoDiagnosticoData,
        medicamentos: result,
        fechaInicio,
        fechaFin,
      })
    );
  } else {
    yield put(
      MedicamentoActions.formMedicamentoDiagnosticoSuccess({
        ...formMedicamentoDiagnosticoData,
        fechaInicio,
        fechaFin,
        medicamentos: [],
      })
    );
  }
}

function* modificarDiagnosticoDefinitivo(request) {
  yield put(MedicamentoActions.modificarDiagnosticoDefinitivoLoading());

  const {
    numeroMedicamento,
    diagnosticoDefinitivo,
    codigoDiagnostico,
    diagnostico,
    formMedicamentoDiagnosticoData,
    formHandler,
  } = request.payload;

  const objetoMedicamento = getObjetoMedicamento(numeroMedicamento);

  const modificarDiagnosticoRequest = {
    anio: Number(objetoMedicamento?.anio),
    compania: Number(objetoMedicamento?.compania),
    ramo: Number(objetoMedicamento?.ramo),
    secuencial: Number(objetoMedicamento?.secuencial),
    codigoDiagnostico: cleanString(codigoDiagnostico),
    diagnosticoDefinitivo: diagnosticoDefinitivo
      ? CHECK_DIAGNOSTICO_DEFINITIVO.SI_ES_DEFINITIVO
      : CHECK_DIAGNOSTICO_DEFINITIVO.NO_ES_DEFINITIVO,
  };

  const modificarDiagnosticoResponse = yield call(
    MedicamentoService.modificarDiagnosticoDefinitivo,
    modificarDiagnosticoRequest
  );

  if (
    modificarDiagnosticoResponse?.mensaje?.toUpperCase() ===
    ResponseCode.OK.message
  ) {
    const medicamentos = formMedicamentoDiagnosticoData?.medicamentos.map(
      (medicamento) => {
        if (medicamento.numeroMedicamento === numeroMedicamento) {
          return {
            ...medicamento,
            diagnostico,
            diagnosticoMetaData: {
              ...medicamento.diagnosticoMetaData,
              codigoDiagnostico,
            },
          };
        }
        return medicamento;
      }
    );

    yield put(
      MedicamentoActions.formMedicamentoDiagnosticoSuccess({
        ...formMedicamentoDiagnosticoData,
        medicamentos,
        alertConfig: {
          type: "success",
          title: "Diagnóstico modificado satisfactoriamente.",
          onConfirm: () => {
            formHandler({
              ...formMedicamentoDiagnosticoData,
              medicamentos,
              showAlert: false,
              showModalModificarDiagnostico: false,
            });
          },
        },
        showAlert: true,
        showModalModificarDiagnostico: false,
      })
    );
  } else {
    yield put(
      MedicamentoActions.formMedicamentoDiagnosticoSuccess({
        ...formMedicamentoDiagnosticoData,
        alertConfig: {
          type: "error",
          title: "¡Hola!",
          message: "Ocurrió un error inesperado al modificar el diagnóstico.",
          onConfirm: () => {
            formHandler({
              ...formMedicamentoDiagnosticoData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      })
    );
  }
}

function* confirmarDiagnosticoDefinitivo(request) {
  yield put(MedicamentoActions.confirmarDiagnosticoDefinitivoLoading());

  const { numeroMedicamento, formMedicamentoDiagnosticoData, formHandler } =
    request.payload;

  const objetoMedicamento = getObjetoMedicamento(numeroMedicamento);

  const modificarDiagnosticoRequest = {
    anio: Number(objetoMedicamento?.anio),
    compania: Number(objetoMedicamento?.compania),
    ramo: Number(objetoMedicamento?.ramo),
    secuencial: Number(objetoMedicamento?.secuencial),
    diagnosticoDefinitivo: CHECK_DIAGNOSTICO_DEFINITIVO.SI_ES_DEFINITIVO,
  };

  const modificarDiagnosticoResponse = yield call(
    MedicamentoService.modificarDiagnosticoDefinitivo,
    modificarDiagnosticoRequest
  );

  if (
    modificarDiagnosticoResponse?.mensaje?.toUpperCase() ===
    ResponseCode.OK.message
  ) {
    const medicamentos = formMedicamentoDiagnosticoData?.medicamentos.map(
      (medicamento) => {
        if (medicamento.numeroMedicamento === numeroMedicamento) {
          return {
            ...medicamento,
            esDiagnosticoDefinitivo: true,
            estado: ESTADO_DIAGNOSTICO_DEFINITIVO.CONFIRMADO,
          };
        }
        return medicamento;
      }
    );

    yield put(
      MedicamentoActions.formMedicamentoDiagnosticoSuccess({
        ...formMedicamentoDiagnosticoData,
        medicamentos,
        alertConfig: {
          type: "success",
          title: "Diagnóstico confirmado satisfactoriamente.",
          onConfirm: () => {
            formHandler({
              ...formMedicamentoDiagnosticoData,
              medicamentos,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      })
    );
  } else {
    yield put(
      MedicamentoActions.formMedicamentoDiagnosticoSuccess({
        ...formMedicamentoDiagnosticoData,
        alertConfig: {
          type: "error",
          title: "¡Hola!",
          message:
            "Ocurrió un error inesperado al marcar el diagnóstico como definitivo.",
          onConfirm: () => {
            formHandler({
              ...formMedicamentoDiagnosticoData,
              showAlert: false,
            });
          },
        },
        showAlert: true,
      })
    );
  }
}

function* descargarReporteVoucher(request) {
  yield put(MedicamentoActions.descargarReporteVoucherLoading());

  yield call(AutorizacionService.descargarReporteVoucher, request.payload);

  yield put(
    MedicamentoActions.descargarReporteVoucherSuccess(ResponseCode.OK)
  );
}

function* buscarMedicamentosOrdsInfoplan(request) {
  yield put(MedicamentoActions.buscarMedicamentosOrdsInfoplanLoading());

  try {
    const { descripcion, offset, limit, numeroSesion } = request.payload;

    if (!descripcion || descripcion.trim() === "") {
      yield put(
        MedicamentoActions.buscarMedicamentosOrdsInfoplanFailure({
          codigo: ResponseCode.BAD_REQUEST.code,
          mensaje: "La descripción del medicamento es requerida",
        })
      );
      return;
    }

    const medicamentosResponse = yield call(
      OrdsInfoplanService.buscarMedicamentos,
      {
        descripcion: descripcion.trim(),
        offset: offset || 0,
        limit: limit || 25,
        numeroSesion,
      }
    );

    if (!medicamentosResponse?.items) {
      yield put(
        MedicamentoActions.buscarMedicamentosOrdsInfoplanFailure({
          codigo: ResponseCode.SERVER_ERROR.code,
          mensaje: "Error en la respuesta del servicio",
        })
      );
      return;
    }

    yield put(
      MedicamentoActions.buscarMedicamentosOrdsInfoplanSuccess(medicamentosResponse)
    );
  } catch (error) {
    yield put(
      MedicamentoActions.buscarMedicamentosOrdsInfoplanFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error al buscar medicamentos",
      })
    );
  }
}

function* notificarReclamacion(request) {
  yield put(MedicamentoActions.notificarReclamacionLoading());

  try {
    const { numeroSesion, requestData } = request.payload;

    const notificarReclamacionResponse = yield call(
      MedicamentoService.notificarReclamacion,
      {
        numeroSesion,
        requestData,
      }
    );

    yield put(
      MedicamentoActions.notificarReclamacionSuccess(notificarReclamacionResponse)
    );
  } catch (error) {
    yield put(
      MedicamentoActions.notificarReclamacionFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: error?.message || "Error al notificar reclamación",
      })
    );
  }
}

const exportedArray = [
  takeLatest(MedicamentoTypes.CREAR_MEDICAMENTO, crearMedicamento),
  takeLatest(MedicamentoTypes.CANCELAR_MEDICAMENTO, cancelarMedicamento),
  takeLatest(MedicamentoTypes.GET_MEDICAMENTO, getMedicamento),
  takeLatest(MedicamentoTypes.REACTIVAR_MEDICAMENTO, reactivarMedicamento),
  takeLatest(
    MedicamentoTypes.CONSULTAR_MEDICAMENTOS,
    consultarMedicamentos
  ),
  takeLatest(
    MedicamentoTypes.LIMPIAR_DATOS_MEDICAMENTO,
    limpiarDatosMedicamento
  ),
  takeLatest(
    MedicamentoTypes.FORM_MEDICAMENTO_DIAGNOSTICO,
    formMedicamentoDiagnostico
  ),
  takeLatest(
    MedicamentoTypes.GET_MEDICAMENTOS_DIAGNOSTICO,
    getMedicamentosDiagnostico
  ),
  takeLatest(
    MedicamentoTypes.MODIFICAR_DIAGNOSTICO_DEFINITIVO,
    modificarDiagnosticoDefinitivo
  ),
  takeLatest(
    MedicamentoTypes.CONFIRMAR_DIAGNOSTICO_DEFINITIVO,
    confirmarDiagnosticoDefinitivo
  ),
  takeLatest(
    MedicamentoTypes.DESCARGAR_REPORTE_VOUCHER,
    descargarReporteVoucher
  ),
  takeLatest(
    MedicamentoTypes.BUSCAR_MEDICAMENTOS_ORDS_INFOPLAN,
    buscarMedicamentosOrdsInfoplan
  ),
  takeLatest(
    MedicamentoTypes.NOTIFICAR_RECLAMACION,
    notificarReclamacion
  ),
];

export default exportedArray;
